// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__BnVJG"};